import QRCode from 'qrcode';

/**
 * Generates an image data URL of a QR code with the given text
 * @param {string} text
 * @returns {Promise<string>} - image data url
 */
export const generateQR = async text => QRCode.toDataURL(text, { width: 300 });
